(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CheckController', CheckController);

    CheckController.$inject = ['$timeout', 'Profile'];

    function CheckController ($timeout, Profile) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.check = check;
        vm.requestDelete = requestDelete;
        vm.lastName = '';
        vm.firstName = '';
        vm.email = '';
        vm.found = false;
        vm.notFound = false;
        vm.deleteRequested = false;

        $timeout(function (){angular.element('#lastName').focus();});

        function check () {
            vm.error = null;
            vm.errorEmailNotExists = null;
            vm.errorMessage = null;
            vm.deleteRequested = false;
            Profile.check({lastName: vm.lastName, firstName: vm.firstName, email: vm.email}, onSuccess, onError);
        }

        function requestDelete () {
            Profile.requestDelete({lastName: vm.lastName, firstName: vm.firstName, email: vm.email}, onDeleteRequestSuccess, onError);
        }


        function onSuccess(data, headers) {
            vm.notFound = data.found === 'false';
            vm.found = data.found === 'true';
            vm.errorMessage = null;
            vm.deleteRequested = false;
        }

        function onDeleteRequestSuccess(data, headers) {
            vm.deleteRequested = true;
            vm.errorMessage = null;
        }

        function onError(response) {
            if (response.status === 404) {
                vm.notFound = true;
                vm.found = false;
                vm.errorMessage = null;
                vm.deleteRequested = false;
            } else if (response.status === 429) {
                vm.notFound = false;
                vm.found = false;
                vm.deleteRequested = false;
                vm.errorMessage = "Trop de tentatives. Merci de réessayer ultérieurement.";
            } else if (response.status === 400) {
                vm.notFound = false;
                vm.found = false;
                vm.deleteRequested = false;
                vm.errorMessage = "Merci de vérifier les champs de saisie.";
            } else if (response.status === 409) {
                vm.notFound = false;
                vm.found = true;
                vm.deleteRequested = false;
                vm.errorMessage = "Demande de suppression impossible. Une suppression a déja été demandée. Nous vous invitons à contacter contact@axenteev.com pour plus de renseignements.";
            } else {
                vm.notFound = false;
                vm.found = false;
                vm.deleteRequested = false;
                vm.errorMessage = "Une erreur est survenue.";
            }
        }

    }
})();
